/* This view is the app header that is always shown when logged in. It includes app logo and name,
   tabs for "Find Clubs", "My clubs", and "My profile" and also a logout button */

import { useState, useRef, useEffect } from "react";
import logo from "../styling/logo.png";
import { Search, Users, LogOut, Menu, X, User } from "lucide-react";
import { ProfileButton } from '../components/profileButton';
import { useNavigate, useLocation, Link } from "react-router-dom";

export default function HeaderView(props){
    const navigate = useNavigate();
    const location = useLocation();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const isFindClubs = location.pathname === "/findClubs";
    const isMyClubs = location.pathname === "/myClubs";
    const isProfile = location.pathname === "/profile";
    const menuRef = useRef(null); // Ref till dropdown menyn

    // Funktionen för att stänga menyn om man klickar utanför
    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMobileMenuOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuRef]);


    function goToMyClubsACB(){
    navigate("/myClubs");
    }

    function goToFindClubsACB(){
        navigate("/findClubs");
    }

    function goToMyProfileACB(){
        console.log("pressed profile button")
        navigate("/profile");
    }
    function logoutButtonACB(){
        props.onLogout();
    }
    return <header className="bg-gray-100 ">
            {/* Navigation bar */}
            <nav className="relative z-10 flex items-center justify-between h-12 md:h-16 bg-white shadow-md border-b border-blue-100">
                
                <div className="header-view flex items-center justify-between w-full h-full">
                    <div className="flex items-center gap-2 ml-2 md:ml-4 lg:ml-4">
                        <img src={logo} alt="Logo" className="h-9 w-9 rounded-xl md:h-12 md:w-12 md:rounded-2xl"/>
                        {/* App name */}
                        <span className="text-sm whitespace-nowrap md:text-base">
                        <Link to="/myClubs" className="!text-blue-900 no-underline !hover:text-blue-800">Clubbing Books</Link>
                        </span> 
                    </div>
                    {/* Centered buttons for find clubs and my clubs */}
                    <div className="hidden md:flex flex-1 justify-center gap-4">
                        <button className={`app-button ${isFindClubs ? 'is-active' : ''} !rounded-lg`}
                            onClick={goToFindClubsACB}>
                            <Search className="w-4 h-4"/>
                            <span>Find Clubs</span>
                        </button>
                    
                        <button className={`app-button ${isMyClubs ? 'is-active' : ''} !rounded-lg`}
                            onClick={goToMyClubsACB}>
                            <Users className="w-4 h-4" />
                            <span>My Clubs</span>
                        </button>
                    </div>
                    {/* Buttons to the right for profile and logout */}
                    <div className="flex items-center gap-3 md:gap-4 md:mr-5">
                        <ProfileButton className={`app-button ${isProfile ? 'is-active' : ''} hidden md:flex py-1.5 lg: py-1 !rounded-lg`} user={props.currentUser} 
                        goToProfile={goToMyProfileACB}/>
                        <button 
                            onClick={logoutButtonACB} 
                            className="hidden md:flex app-button py-1.5 !rounded-lg">
                            <LogOut className="w-4 h-4" />
                            <span>Logout</span>
                        </button>
                        {/* Hamburger icon on mobile */}
                        <div className="pr-2 md:hidden">
                            <button className="text-blue-700" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                            {mobileMenuOpen ? <X className="w-6 h-6"/> : <Menu className="w-6 h-6"/>}
                            </button>
                        </div>
                        
                    </div>

                    {/* Mobile dropdown menu */}
                    {mobileMenuOpen && (
                        <div className="absolute top-full left-0 w-full bg-white shadow-md z-20 flex flex-col p-4 gap-2 md:hidden">
                            <button className="app-button w-full text-left" onClick={() => { goToFindClubsACB(); setMobileMenuOpen(false); }}>
                                <Search className="w-4 h-4 inline mr-0.25"/>
                                Find Clubs
                            </button>
                            <button className="app-button w-full text-left" onClick={() => { goToMyClubsACB(); setMobileMenuOpen(false); }}>
                                <Users className="w-4 h-4 inline mr-0.25"/>
                                My Clubs
                            </button>
                            <button className="app-button w-full text-left" onClick={() => { goToMyProfileACB(); setMobileMenuOpen(false); }}>
                                <User className="w-4 h-4 inline mr-0.25"/>
                                My Profile
                            </button>
                            <button className="app-button w-full text-left" onClick={logoutButtonACB} >
                                <LogOut className="w-4 h-4 inline mr-0.25" />
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            </nav>
        </header>
    

}